import request from '../request';

export default{
    getAll: async () => {
        return request.get('/geofencing');
    },
    update: async (body) => {
        return request.post('/geofencing', body);
    },
}
